import { useState } from "react";
import { useParams } from "react-router-dom";
import { publicPost } from "../lib/api";

export default function CsatPage() {
  const { ticketId } = useParams<{ ticketId: string }>();
  const [submitted, setSubmitted] = useState<number | null>(null);
  const [error, setError] = useState("");

  const submit = async (score: number) => {
    if (!ticketId) return;
    setError("");
    try {
      await publicPost(`/api/tickets/${ticketId}/csat`, { csat: score });
      setSubmitted(score);
    } catch (err) {
      setError((err as Error).message);
    }
  };

  if (submitted != null) {
    return (
      <div className="public-shell">
        <h2>Bedankt!</h2>
        <p>Je score van {submitted}/5 is opgeslagen.</p>
      </div>
    );
  }

  return (
    <div className="public-shell">
      <h2>Hoe tevreden was je?</h2>
      <p>Klik op een score om je beoordeling door te geven.</p>
      <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} className="primary" style={{ width: 60, height: 60, fontSize: 18 }} onClick={() => submit(n)}>
            {n}
          </button>
        ))}
      </div>
      {error && <div style={{ color: "var(--danger)", marginTop: 12 }}>{error}</div>}
    </div>
  );
}
